export enum LeaseDocumentsApiPath {
  LANDLORD_LEASE_DOCUMENTS = 'irent/User/lease',
  MASTER_AGREEMENT = 'irent/lease/master-agreements',
  SENT_LEASES = 'irent/lease/sent-leases',
}
